import React, { useState } from 'react';
import { Link } from 'gatsby';
import Section from '../section/section';
import Filters from '../../../components/filter/filters';
import { Tag } from '../../../components/tag/tag-component';

interface IBlogPrimarySectionProps {
  title: string;
  filters: string[];
  primaryArticle?: {
    image: { src: string; alt: string };
    timeToRead: string;
    title: string;
    description: string;
    category: string;
    link: string;
  };
  onFilterChange?: (filter: string) => void;
}

const BlogPrimarySection = ({ title, filters, primaryArticle, onFilterChange }: IBlogPrimarySectionProps) => {
  const [activeFilter, setActiveFilter] = useState(filters[0]);

  const handleFilterChange = (filter: string) => {
    setActiveFilter(filter);
    onFilterChange?.(filter);
  };

  return (
    <section
      style={{ background: 'linear-gradient(90deg, rgba(169, 87, 226, 0.08) 0%, rgba(55, 148, 212, 0.08) 100%)' }}>
      <Section className="blog-primary-section" style={{ paddingBottom: primaryArticle ? undefined : '64px' }}>
        <h1 className="blog-primary-section__title">{title}</h1>

        <Filters
          className="blog-primary-section__filters"
          filters={filters}
          activeFilter={activeFilter}
          onFilterChange={handleFilterChange}
        />

        {primaryArticle && (
          <Link to={primaryArticle.link}>
            <div className="blog-primary-section__article-preview">
              <div className="blog-primary-section__article-preview__image">
                <img src={primaryArticle.image.src} alt={primaryArticle.image.alt} />
              </div>
              <div className="blog-primary-section__article-preview__content">
                <div className="blog-primary-section__article-preview__content__time-to-read">
                  {primaryArticle.timeToRead}
                </div>
                <Tag text={{ text: primaryArticle.category }} />
                <h3 className="blog-primary-section__article-preview__content__title">
                  <span className="blog-primary-section__article-preview__content__title__black">
                    {primaryArticle.title}
                  </span>
                  <span className="blog-primary-section__article-preview__content__title__gradient">
                    {primaryArticle.title}
                  </span>
                </h3>
                <p className="blog-primary-section__article-preview__content__description">
                  {primaryArticle.description}
                </p>
              </div>
            </div>
          </Link>
        )}
      </Section>
    </section>
  );
};

export default BlogPrimarySection;
